import React from "react";
import { motion } from "framer-motion";

const AboutUsPromise: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const words = [
    "Estamos",
    "comprometidos",
    "a",
    "hacer",
    "de",
    "Grupo Peña Defilló",
    "un",
    "lugar",
    "donde",
    "las",
    "personas",
    "puedan",
    "realizar",
    "el",
    "mejor trabajo",
    "de",
    "su",
    "carrera",
    "de",
    "manera",
    "sostenible.",
  ];

  return (
    <div className="w-full h-screen bg-white flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-5xl"
      >
        <motion.div
          initial={{ opacity: 0, y: 100, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.5, ease: "backOut" }}
          className="flex flex-col items-center justify-center relative"
        >
          <motion.h3
            className="text-[#343434] text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold font-montserrat text-left lg:text-center leading-relaxed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            {words.map((word, index) => (
              <motion.span
                key={index}
                initial={{
                  opacity: 0,
                  y: 50,
                  rotateX: -90,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                  rotateX: 0,
                }}
                transition={{
                  duration: 0.6,
                  delay: 0.8 + index * 0.1,
                  ease: "backOut",
                }}
                className={`inline-block mr-2 ${"font-bold font-montserrat text-[#343434]"} relative`}
              >
                {word}{" "}
              </motion.span>
            ))}
          </motion.h3>
        </motion.div>
      </motion.div>

      {/* Animated background elements */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.02 }}
        transition={{ duration: 2, delay: 3 }}
        className="absolute inset-0 pointer-events-none"
      >
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            initial={{
              opacity: 0,
              x:
                Math.random() *
                (typeof window !== "undefined" ? window.innerWidth : 1000),
              y:
                Math.random() *
                (typeof window !== "undefined" ? window.innerHeight : 1000),
            }}
            animate={{
              opacity: [0, 0.05, 0],
              scale: [0.5, 1, 0.5],
              x: [
                Math.random() *
                  (typeof window !== "undefined" ? window.innerWidth : 1000),
                Math.random() *
                  (typeof window !== "undefined" ? window.innerWidth : 1000) +
                  50,
                Math.random() *
                  (typeof window !== "undefined" ? window.innerWidth : 1000),
              ],
              y: [
                Math.random() *
                  (typeof window !== "undefined" ? window.innerHeight : 1000),
                Math.random() *
                  (typeof window !== "undefined" ? window.innerHeight : 1000) -
                  100,
                Math.random() *
                  (typeof window !== "undefined" ? window.innerHeight : 1000),
              ],
            }}
            transition={{
              duration: Math.random() * 4 + 3,
              delay: Math.random() * 3 + 3,
              repeat: Infinity,
              repeatDelay: Math.random() * 2 + 1,
            }}
            className="absolute w-1 h-1 bg-gray-400 rounded-full"
          />
        ))}
      </motion.div>
    </div>
  );
};

export default AboutUsPromise;
